<ng-container *ngIf="address">
  <ng-container *ngIf="address.street1">{{ address.street1 }}<br></ng-container>
  <ng-container *ngIf="address.street2">{{ address.street2 }}<br></ng-container>
  <ng-container *ngIf="address.city">{{ address.city }}</ng-container><!--
  --><ng-container *ngIf="address.city && (address.stateProvince || address.postalCode)">, </ng-container>
  <ng-container *ngIf="address.stateProvince">{{ address.stateProvince }}</ng-container>
  <ng-container *ngIf="address.postalCode"> {{ FormattedPostalCode }}</ng-container>
  <ng-container *ngIf="displayCountry && address.country"><br>{{ address.country }}</ng-container>
</ng-container>
